import { render, staticRenderFns } from "./TopicCommonEmpty.vue?vue&type=template&id=388a46c8&scoped=true"
import script from "./TopicCommonEmpty.vue?vue&type=script&lang=js"
export * from "./TopicCommonEmpty.vue?vue&type=script&lang=js"
import style0 from "./TopicCommonEmpty.vue?vue&type=style&index=0&id=388a46c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a46c8",
  null
  
)

export default component.exports